<template>
  <div class="card__container">
    <div class="card__content">
      <div class="card__item">
        <Heading :level="3" class="card__item-title">Próximas etapas</Heading>
        <Stepper :steps="steps" />
      </div>
      <div class="card__item">
        <Heading :level="3" class="card__item-title">Cotização</Heading>
        <BaseText
          class="card__item-description"
          as="p"
          size="md"
          :color="NebraskaColors.textSecondary"
        >
          A cotização é o período entre o pedido do resgate e a conversão de
          suas cotas em dinheiro, é nessa etapa que o valor líquido de resgate
          para cada produto é definido.
        </BaseText>
      </div>
      <div class="card__item">
        <Heading :level="3" class="card__item-title">Liquidação</Heading>
        <BaseText
          class="card__item-description"
          as="p"
          size="md"
          :color="NebraskaColors.textSecondary"
        >
          É o período para que o valor final seja depositado na sua conta depois
          da cotização. O resgate de cada produto entrará separadamente em sua
          conta digital assim que chegar em sua data de liquidação.
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { IStep, Stepper } from '@/modules/wealth/components/Stepper';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { format } from 'date-fns';

@Component({
  components: {
    Heading,
    BaseText,
    Stepper
  }
})
export default class StatusInformationCard extends Vue {
  public readonly steps: IStep[] = [
    {
      title: 'Solicitação',
      description: format(new Date(), `'Hoje às' HH:mm`),
      active: true
    },
    { title: 'Cotização' },
    { title: 'Liquidação' }
  ];

  public readonly NebraskaColors = NebraskaColors;
}
</script>
<style lang="less" scoped>
.card {
  &__content {
    border: @size-border-x400 solid @divider-primary;
    border-radius: @size-radius-x300;
    padding: @size-spacing-x900 @size-spacing-x1400;
    .to-md({ padding: @size-spacing-x500; });
  }
  &__item {
    &:not(:first-child) {
      margin-top: @size-spacing-x800;
    }
  }
  &__item-title {
    margin-bottom: @size-spacing-x300;
  }
  &__item-total-label,
  &__item-total-value {
    font-weight: 700;
  }
  &__status-message {
    margin-top: @size-spacing-x300;
  }
}
</style>
